import {SubRoute, SubRouteFormField} from "@models/travelAllowance/rideRoute";
import {UseFormMethods} from "react-hook-form";
import {getFieldNameWithPrefix} from "@services/travelAllowance/travelAllowance";

export type SetValue<T = any> = UseFormMethods<T>['setValue'];
export type GetValues<T = any> = UseFormMethods<T>['getValues'];

const transformSubRoutesToFormField = (subRoutes: SubRoute[]): SubRouteFormField[] => {
    return subRoutes.map((subRoute, index) => ({
        startingPlace: subRoute.startingPlace,
        startingPlaceCountry: subRoute.startingPlaceCountry,
        destinationPlace: subRoute.destinationPlace,
        destinationPlaceCountry: subRoute.destinationPlaceCountry,
        distance: subRoute.distance,
        visible: index !== subRoutes.length - 1
    }));
}

const updateSubRouteHiddenFields = (subRoutes: SubRouteFormField[], setValue: SetValue, getValues: GetValues, prefix: string | undefined = undefined) => {
    subRoutes.forEach((subRoute: SubRouteFormField, index: number) => {
        const startingPlaceField = getFieldNameWithPrefix(`subRoutes.${index}.startingPlace`, prefix);
        const destinationPlaceField = getFieldNameWithPrefix(`subRoutes.${index}.destinationPlace`, prefix);
        const startingPlaceCountryField = getFieldNameWithPrefix(`subRoutes.${index}.startingPlaceCountry`, prefix);
        const destinationPlaceCountryField = getFieldNameWithPrefix(`subRoutes.${index}.destinationPlaceCountry`, prefix);

        if (index > 0 && index !== subRoutes.length - 1) {
            setValue(startingPlaceField, getValues(getFieldNameWithPrefix(`subRoutes.${index - 1}.destinationPlace`, prefix)));
            setValue(startingPlaceCountryField, getValues(getFieldNameWithPrefix(`subRoutes.${index - 1}.destinationPlaceCountry`, prefix)));
        }

        if (index === 0) {
            setValue(startingPlaceField, getValues(getFieldNameWithPrefix('startingPlace', prefix)));
            setValue(startingPlaceCountryField, getValues(getFieldNameWithPrefix('startingPlaceCountry', prefix)));
        }

        if (index === subRoutes.length - 1) {
            setValue(startingPlaceField, getValues(getFieldNameWithPrefix(`subRoutes.${index - 1}.destinationPlace`, prefix)));
            setValue(startingPlaceCountryField, getValues(getFieldNameWithPrefix(`subRoutes.${index - 1}.destinationPlaceCountry`, prefix)));
            setValue(destinationPlaceField, getValues(getFieldNameWithPrefix('destinationPlace', prefix)));
            setValue(destinationPlaceCountryField, getValues(getFieldNameWithPrefix('destinationPlaceCountry', prefix)));
        }
    });
}

const validateSubRoutes = (subRoutes: SubRouteFormField[]) => {
    let isValid = true;

    subRoutes.forEach((subRoute) => {
        if (!subRoute.startingPlace || !subRoute.destinationPlace) {
            isValid = false;
        }
    });

    return isValid;
}

export {
    transformSubRoutesToFormField,
    updateSubRouteHiddenFields,
    validateSubRoutes,
};
